
(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const data = {
            firstName: document.querySelector('meta[name="first_name"]')?.content ?? '',
            lastName: document.querySelector('meta[name="last_name"]')?.content ?? '',
            preferredName: document.querySelector('meta[name="preferred_name"]')?.content ?? '',
        };

        const name = data.preferredName ? data.preferredName : data.firstName;
        const title = document.querySelector('[data-profile-experience-title]');

        if (name && title) {
            const nameSplit = name.split("");
            const lastLetter = nameSplit.at(-1);

            title.innerHTML = lastLetter && lastLetter.match(/s/) ? `${ name }' experience` : `${name}'s experience`;
        }
    });
})();
